/*
  BIONIKA (2026-10-07): ha a vevő a min. 10 db alá próbálja csökkenteni egy készleten
  nem lévő variáns mennyiségét, rövid értesítőt mutatunk, és ajánljuk a készleten lévő
  variánsokat (a main-product.liquid `bnk-min10-variants` JSON-ja alapján).
*/
(function () {
  if (window.__bnkMin10) return;
  window.__bnkMin10 = true;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = EN
    ? { msg: 'This variant is currently out of stock, so the minimum order quantity is {n} pcs.', alt: 'In-stock variants:' }
    : { msg: 'Ebből a változatból jelenleg nincs készlet, ezért legalább {n} db rendelhető.', alt: 'Készleten lévő változatok:' };

  function adatok(input) {
    var root = input.closest('product-info') || document;
    var el = root.querySelector('script[data-bnk-min10]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function aktualisId(input) {
    var f = document.getElementById(input.getAttribute('form'));
    var id = f && f.querySelector('[name="id"]');
    return id ? parseInt(id.value, 10) : null;
  }
  function gyoker(input) { return input.closest('product-info') || input.closest('section') || document; }
  function doboz(input) { return gyoker(input).querySelector('.bnk-min10-notice'); }
  // a kosárba gomb (product-form) alá tesszük, hogy ne tolja le a gombot
  function hely(input) {
    var root = gyoker(input);
    var f = document.getElementById(input.getAttribute('form'));
    return (f && f.closest('product-form')) || root.querySelector('product-form') || input.closest('.product-form__quantity');
  }
  function elrejt(input) { var d = input && doboz(input); if (d) d.remove(); }
  function mutat(input) {
    var min = parseInt(input.dataset.min || '1', 10);
    if (min < 10) return;
    var a = adatok(input);
    if (!a) return;
    var cur = aktualisId(input);
    var v = null;
    for (var i = 0; i < a.v.length; i++) if (a.v[i].id === cur) v = a.v[i];
    if (!v || v.k) return;
    var jo = a.v.filter(function (x) { return x.k && x.id !== cur; });
    jo.forEach(function (x) {
      x._p = 0;
      for (var j = 0; j < x.o.length; j++) if (x.o[j] === v.o[j]) x._p++;
    });
    jo.sort(function (x, y) { return y._p - x._p; });
    jo = jo.slice(0, 6);
    elrejt(input);
    var d = document.createElement('div');
    d.className = 'bnk-min10-notice';
    d.setAttribute('role', 'status');
    var p = document.createElement('p');
    p.textContent = T.msg.replace('{n}', min);
    d.appendChild(p);
    if (jo.length) {
      var p2 = document.createElement('p');
      p2.className = 'bnk-min10-notice__alt';
      p2.textContent = T.alt;
      d.appendChild(p2);
      var ul = document.createElement('ul');
      jo.forEach(function (x) {
        var li = document.createElement('li');
        var l = document.createElement('a');
        l.href = a.u + (a.u.indexOf('?') < 0 ? '?' : '&') + 'variant=' + x.id;
        l.textContent = x.t;
        l.dataset.o = JSON.stringify(x.o);
        li.appendChild(l);
        ul.appendChild(li);
      });
      d.appendChild(ul);
    }
    var h = hely(input);
    h.parentNode.insertBefore(d, h.nextSibling);
  }

  // ajánlott variáns: újratöltés helyett a variánsválasztókat állítjuk át (Dawn variant-selects)
  function valt(link) {
    var root = link.closest('product-info') || document;
    var vs = root.querySelector('variant-selects');
    var o = JSON.parse(link.dataset.o || '[]');
    if (!vs || !o.length) return false;
    var mezok = vs.querySelectorAll('.product-form__input');
    if (mezok.length !== o.length) return false;
    var cel = [];
    for (var i = 0; i < o.length; i++) {
      var sel = mezok[i].querySelector('select');
      if (sel) {
        var op = Array.prototype.filter.call(sel.options, function (x) { return x.value === o[i]; })[0];
        if (!op) return false;
        cel.push({ s: sel, el: op });
      } else {
        var inp = Array.prototype.filter.call(mezok[i].querySelectorAll('input[type="radio"]'), function (x) { return x.value === o[i]; })[0];
        if (!inp) return false;
        cel.push({ el: inp });
      }
    }
    var utolso = null;
    cel.forEach(function (c) {
      if (c.s) {
        if (c.s.value === c.el.value) return;
        Array.prototype.forEach.call(c.s.options, function (x) { x.toggleAttribute('selected', x === c.el); });
        c.s.value = c.el.value; utolso = c.s;
      } else if (!c.el.checked) {
        c.el.checked = true; utolso = c.el;
      }
    });
    if (utolso) utolso.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  document.addEventListener('click', function (e) {
    var al = e.target.closest && e.target.closest('.bnk-min10-notice a[data-o]');
    if (al) {
      if (valt(al)) e.preventDefault();
      return;
    }
    var b = e.target.closest && e.target.closest('quantity-input .quantity__button[name="minus"]');
    if (!b) return;
    var input = b.closest('quantity-input').querySelector('.quantity__input');
    var min = parseInt(input.dataset.min || '1', 10);
    // Dawn előbb fut (a gombon), utána a dokumentumon mi: ha a minimumon áll, csökkenteni akart
    if (parseInt(input.value || '0', 10) <= min) mutat(input);
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.classList && t.classList.contains('quantity__input')) {
      var min = parseInt(t.dataset.min || '1', 10);
      var val = parseInt(t.value || '0', 10);
      if (min >= 10 && val < min) {
        t.value = min;
        mutat(t);
      } else if (val > min) {
        elrejt(t);
      }
      return;
    }
    // variánsváltás: régi értesítő el
    var pi = t.closest && t.closest('product-info');
    if (pi) pi.querySelectorAll('.bnk-min10-notice').forEach(function (d) { d.remove(); });
  });

  // 2026-10-08: nem készletes variáns kiválasztásakor (és betöltéskor) is megjelenik.
  // A product-info.js a variánsváltás után írja át a data-min-t, a részleges
  // választásnál a bnk-variant-autoselect.js visszaveszi — mindkettőt követjük.
  function frissit(input) {
    if (parseInt(input.dataset.min || '1', 10) >= 10) mutat(input);
    else elrejt(input);
  }
  function mind() {
    Array.prototype.forEach.call(document.querySelectorAll('product-info .quantity__input'), frissit);
  }
  new MutationObserver(function (ms) {
    var volt = false;
    ms.forEach(function (m) {
      if (m.type === 'attributes') {
        if (m.target.classList.contains('quantity__input') && m.target.closest('product-info')) frissit(m.target);
      } else {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1 && (n.matches('.quantity__input') || n.querySelector('.quantity__input'))) volt = true;
        });
      }
    });
    if (volt) mind();
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-min'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mind);
  else mind();
})();
